import { render, staticRenderFns } from "./number_input.vue?vue&type=template&id=4ae0b21a"
import script from "./number_input.vue?vue&type=script&lang=ts"
export * from "./number_input.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports